import PropTypes from "prop-types";
import { useParams } from 'react-router-dom'
import React, { useEffect, useState, useContext } from 'react';
import ProductApi from "@apis/ProductApi";
// import ProductDetailPage from "./ProductDetailPage";
import EntityFetcher from "@/core/EntityFetcher";
import { ProductContext } from "@/core/providers/ProductContext";
import BackToTop from "@/base/BackToTop";
import { BreadcrumbContext } from "@/core/providers/BreadcrumbContext";


const ProductsPage = ({ preview }) => {

  const { slug } = useParams();
  const [loading, setLoading] = useState(true)
  const {setProduct} = useContext(ProductContext);
  const {setBreadcrumbs} = useContext(BreadcrumbContext);
  // const [product, setProduct] = useState(null)

  // Load the product data.
  useEffect(() => {
    (async () => {
      const api = new ProductApi();
      const product = await api.getProductDataBySlug(slug);
      setProduct(product);
      setLoading(false);

      if ( product ){

          let sectionsOfParentProductURL = product.key.split("/");

          setBreadcrumbs([
            { label: product.major_label, path: "/products/" + sectionsOfParentProductURL[0] },
            { label: product.minor_label, path: window.location.pathname },
          ]);
      }

      

      
    })()
  }, [slug, setProduct, setBreadcrumbs]);

  if (!slug) {
    return <div>No Slug specified. Product General page?</div>
  }

  // TODO : Add loading spinner/component
  if (loading) return <div>Loading...</div>;

  return (
      <React.Fragment>
        <EntityFetcher preview={preview} />
        <BackToTop />
      </React.Fragment>
  )

};

ProductsPage.propTypes = {
  preview: PropTypes.bool
};

export default ProductsPage;
